var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-account-stake account-main-content-mt"},[_c(_vm.currentComponent,_vm._b({tag:"component",on:{"change-component":_vm.onChangeComponent}},'component',_vm.currentComponentProperties,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }